import {i18n} from 'src/i18n';
import AbsenceService from 'src/modules/absence/absenceService';
import listActions from 'src/modules/absence/list/absenceListActions';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';

const prefix = 'ABSENCE_DESTROY';

const absenceDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy:
    (id, deleted: any = null) =>
    async (dispatch) => {
      try {
        dispatch({
          type: absenceDestroyActions.DESTROY_STARTED,
        });

        await AbsenceService.destroyAll([id]);

        dispatch({
          type: absenceDestroyActions.DESTROY_SUCCESS,
        });

        Message.success(i18n('entities.absence.destroy.success'));

        dispatch(listActions.doFetchCurrentFilter());

        if (deleted) {
          deleted(id);
        } else {
          //getHistory().push('/ausencia');
        }
      } catch (error) {
        Errors.handle(error);

        dispatch(listActions.doFetchCurrentFilter());

        dispatch({
          type: absenceDestroyActions.DESTROY_ERROR,
        });
      }
    },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: absenceDestroyActions.DESTROY_ALL_STARTED,
      });

      await AbsenceService.destroyAll(ids);

      dispatch({
        type: absenceDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(i18n('entities.absence.destroyAll.success'));

      //getHistory().push('/ausencia');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: absenceDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default absenceDestroyActions;
